(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').directive('mxBrokenControlStub', function mxBrokenControlStubDirective() {
		return { template: '<div>Control does not exist</div>' };
	});
})();
